import { render, staticRenderFns } from "./ProjectDisabilities.vue?vue&type=template&id=a743e92e&scoped=true&"
import script from "./ProjectDisabilities.vue?vue&type=script&lang=js&"
export * from "./ProjectDisabilities.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDisabilities.vue?vue&type=style&index=0&id=a743e92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a743e92e",
  null
  
)

export default component.exports